<template>
	<div class="help-menu-container">
		<div class="help-menu-search">
			<input type="text" placeholder="搜索标题">
			<span class="help-menu-icon"></span>
		</div>
		<div class="help-menu-list">
			<div class="help-menu-item" v-for="help in helpMenuList">
				<div class="help-menu-parent" @click="parentClick(help)">
					<span class="help-menu-parent-icon" :class="{'help-menu-parent-open': help.id == currentOpenId}"></span>
					<span class="help-menu-parent-text">{{help.title}}</span>
				</div>
				<div class="help-menu-child" v-if="help.id == currentOpenId">
					<div class="help-menu-child-item" @click="childClick(hChild)" :class="{'help-menu-child-item-active':currentId == hChild.id}" v-for="hChild in help.child">
						<span>{{hChild.title}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapGetters } from 'vuex'
	
	export default{
		name:'HelpMenu',
		data(){
			return{
				currentOpenId: 0,
				currentId:0,
				helpMenuList:[
					{
						id:1,
						title:'常见问题',
						child:[
							{
								id:2,
								title:'聊天后台数据异常问题'
							},
							{
								id:3,
								title:'缓存清理问题'
							},
							{
								id:4,
								title:'账号平移问题'
							}	
						]
					},
					{
						id:5,
						title:'案例中心',
						child:[
							{
								id:6,
								title:'聊天后台数据异常问题'
							},
							{
								id:7,
								title:'缓存清理问题'
							},
							{
								id:8,
								title:'账号平移问题'
							}	
						]
					},
					{
						id:9,
						title:'安全中心',
						child:[
							{
								id:10,
								title:'聊天后台数据异常问题'
							},
							{
								id:11,
								title:'缓存清理问题'
							},
							{
								id:12,
								title:'账号平移问题'
							}	
						]
					}
				]
			}
		},
		methods:{
			// 父级菜单点击
			parentClick(item){
				if(this.currentOpenId != item.id){
					this.currentOpenId = item.id
				}else{
					this.currentOpenId = 0
				}				
			},
			
			// 子菜单点击
			childClick(item){
				this.currentId = item.id
			}
		}
	}
</script>

<style>
	.help-menu-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		background-color: #EEEEEE;
		color: #666666;
		user-select: none;
	}
	.help-menu-container .help-menu-search{
		padding: 0 20px;
		overflow: hidden;
		position: relative;
		margin: 10px 0;
	}
	.help-menu-search input{
		display: block;
		height: 30px;
		line-height: 30px;
		width: 100%;
		border: 1px solid #CFCFCF;
		border-radius: 4px;
		padding: 0 10px 0 30px;
		box-sizing: border-box;
		font-size: 12px;
	}
	.help-menu-search input:focus{
		outline: none;
		border: 1px solid #42B983;
	}
	.help-menu-search .help-menu-icon{
		width: 30px;
		height: 30px;
		position: absolute;
		top: 0;
		left: 20px;
		background-image: url(../../assets/img/c-all-search.png);
		background-size: 18px auto;
		background-repeat: no-repeat;
		background-position: center;	
	}
	.help-menu-container .help-menu-list{
		position: absolute;
		top: 50px;
		left: 0;
		right: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.help-menu-list .help-menu-item{
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.help-menu-item .help-menu-parent{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 26px;
		cursor: pointer;
		padding: 5px 20px;
	}
	.help-menu-parent:hover{
		background-color: #e1e1e1;
	}
	.help-menu-parent span{
		display: block;
	}
	.help-menu-parent .help-menu-parent-icon{
		width: 10px;
		height: 26px;
		margin-right: 5px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-image: url(../../assets/img/right-arrow-70-32.png);
	}
	.help-menu-parent .help-menu-parent-open{
		background-image: url(../../assets/img/down-arrow-70-32.png);
	}
	.help-menu-parent .help-menu-parent-text{
		width: 0;
		height: 26px;
		flex-grow: 1;
		overflow: hidden;
		line-height: 26px;
	}
	.help-menu-item .help-menu-child{
		width: 100%;
		font-size: 12px;
	}
	.help-menu-child .help-menu-child-item{
		display: block;
		padding: 5px 20px 5px 35px;
		height: 26px;
		line-height: 26px;
		overflow: hidden;
		cursor: pointer;
	}
	.help-menu-child .help-menu-child-item:hover{
		background-color: #e1e1e1;
	}
	.help-menu-child-item-active{
		background-color: #e1e1e1;
	}
	.help-menu-child-item span{
		display: inline-block;
		width: 100%;
		height: 26px;
		line-height: 26px;
		overflow: hidden;
	}
</style>
